webpackJsonp([198],{

/***/ 2854:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2855);


/***/ }),

/***/ 2855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ../node_modules/web-vitals/dist/web-vitals.js
var t,e,n,i,a=function(t,e){return{name:t,value:void 0===e?-1:e,delta:0,entries:[],id:"v1-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12)}},r=function(t,e){try{if(PerformanceObserver.supportedEntryTypes.includes(t)){var n=new PerformanceObserver((function(t){return t.getEntries().map(e)}));return n.observe({type:t,buffered:!0}),n}}catch(t){}},o=!1,c=function(t,e){o||"undefined"!=typeof InstallTrigger||(addEventListener("beforeunload",(function(){})),o=!0);addEventListener("visibilitychange",(function n(i){"hidden"===document.visibilityState&&(t(i),e&&removeEventListener("visibilitychange",n,!0))}),!0)},u=function(t){addEventListener("pageshow",(function(e){e.persisted&&t(e)}),!0)},f="function"==typeof WeakSet?new WeakSet:new Set,s=function(t,e,n){var i;return function(){e.value>=0&&(n||f.has(e)||"hidden"===document.visibilityState)&&(e.delta=e.value-(i||0),(e.delta||void 0===i)&&(i=e.value,t(e)))}},m=function(t,e){var n,i=a("CLS",0),o=function(t){t.hadRecentInput||(i.value+=t.value,i.entries.push(t),n())},f=r("layout-shift",o);f&&(n=s(t,i,e),c((function(){f.takeRecords().map(o),n()})),u((function(){i=a("CLS",0),n=s(t,i,e)})))},d=-1,v=function(){return"hidden"===document.visibilityState?0:1/0},p=function(){c((function(t){var e=t.timeStamp;d=e}),!0)},l=function(){return d<0&&(d=v(),p(),u((function(){setTimeout((function(){d=v(),p()}),0)}))),{get timeStamp(){return d}}},S=function(t,e){var n,i=l(),o=a("FCP"),c=r("paint",(function(t){"first-contentful-paint"===t.name&&(c&&c.disconnect(),t.startTime<i.timeStamp&&(o.value=t.startTime,o.entries.push(t),f.add(o),n()))}));c&&(n=s(t,o,e),u((function(i){o=a("FCP"),n=s(t,o,e),requestAnimationFrame((function(){requestAnimationFrame((function(){o.value=performance.now()-i.timeStamp,f.add(o),n()}))}))})))},h={passive:!0,capture:!0},y=new Date,g=function(i,a){t||(t=a,e=i,n=new Date,L(removeEventListener),E())},E=function(){if(e>=0&&e<n-y){var a={entryType:"first-input",name:t.type,target:t.target,cancelable:t.cancelable,startTime:t.timeStamp,processingStart:t.timeStamp+e};i.forEach((function(t){t(a)})),i=[]}},w=function(t){if(t.cancelable){var e=(t.timeStamp>1e12?new Date:performance.now())-t.timeStamp;"pointerdown"==t.type?function(t,e){var n=function(){g(t,e),a()},i=function(){a()},a=function(){removeEventListener("pointerup",n,h),removeEventListener("pointercancel",i,h)};addEventListener("pointerup",n,h),addEventListener("pointercancel",i,h)}(e,t):g(e,t)}},L=function(t){["mousedown","keydown","touchstart","pointerdown"].forEach((function(e){return t(e,w,h)}))},T=function(n,o){var m,d=l(),v=a("FID"),p=function(t){t.startTime<d.timeStamp&&(v.value=t.processingStart-t.startTime,v.entries.push(t),f.add(v),m())},S=r("first-input",p);m=s(n,v,o),S&&c((function(){S.takeRecords().map(p),S.disconnect()}),!0),S&&u((function(){var r;v=a("FID"),m=s(n,v,o),i=[],e=-1,t=null,L(addEventListener),r=p,i.push(r),E()}))},b=function(t,e){var n,i=l(),o=a("LCP"),m=function(t){var e=t.startTime;e<i.timeStamp&&(o.value=e,o.entries.push(t)),n()},d=r("largest-contentful-paint",m);if(d){n=s(t,o,e);var v=function(){f.has(o)||(d.takeRecords().map(m),d.disconnect(),f.add(o),n())};["keydown","click"].forEach((function(t){addEventListener(t,v,{once:!0,capture:!0})})),c(v,!0),u((function(i){o=a("LCP"),n=s(t,o,e),requestAnimationFrame((function(){requestAnimationFrame((function(){o.value=performance.now()-i.timeStamp,f.add(o),n()}))}))}))}},F=function(t){var e,n=a("TTFB");e=function(){try{var e=performance.getEntriesByType("navigation")[0]||function(){var t=performance.timing,e={entryType:"navigation",startTime:0};for(var n in t)"navigationStart"!==n&&"toJSON"!==n&&(e[n]=Math.max(t[n]-t.navigationStart,0));return e}();n.value=n.delta=e.responseStart,n.entries=[e],t(n)}catch(t){}},"complete"===document.readyState?setTimeout(e,0):addEventListener("pageshow",e)};

// EXTERNAL MODULE: ../globals/dataLayer.ts
var dataLayer = __webpack_require__(169);

// CONCATENATED MODULE: ../shared/js/constants/localStorage.constants.js
var LOCAL_STORAGE_KEYS = {
  CLS_EVENT: 'clsEvent'
};
/* harmony default export */ var localStorage_constants = (LOCAL_STORAGE_KEYS);
// CONCATENATED MODULE: ../utilities/trackCumulativeLayoutShift.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable rover/no-platform-specific-globals-or-imports */


var trackCumulativeLayoutShift_trackCumulativeLayoutShift = function trackCumulativeLayoutShift() {
  try {
    var maxCls = 0;
    var curr = 0;
    var firstTs = Number.NEGATIVE_INFINITY;
    var prevTs = Number.NEGATIVE_INFINITY;
    var observer = new window.PerformanceObserver(function (entryList) {
      // eslint-disable-next-line
      var _iterator = _createForOfIteratorHelper(entryList.getEntries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          // eslint-disable-next-line no-continue
          if (entry.hadRecentInput) continue;

          if (entry.startTime - firstTs > 5000 || entry.startTime - prevTs > 1000) {
            firstTs = entry.startTime;
            curr = 0;
          }

          prevTs = entry.startTime;
          curr += entry.value;
          maxCls = Math.max(maxCls, curr);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe({
      type: 'layout-shift',
      buffered: true
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        var _window$cloudflare, _window$cloudflare2, _navigator$connection;

        if (!observer.takeRecords || !observer.disconnect) return; // Safari and IE11 don't support these features, but it's fine to just not track CLS there

        observer.takeRecords();
        observer.disconnect();
        var htmlEdgeCacheStatus = ((_window$cloudflare = window.cloudflare) === null || _window$cloudflare === void 0 ? void 0 : _window$cloudflare.htmlEdgeCacheStatus) || '';
        var cfCountryCode = ((_window$cloudflare2 = window.cloudflare) === null || _window$cloudflare2 === void 0 ? void 0 : _window$cloudflare2.countryCode) || ''; // $FlowFixMe navigator.connection is a thing in chrome, and this is safe access

        var effectiveType = ((_navigator$connection = navigator.connection) === null || _navigator$connection === void 0 ? void 0 : _navigator$connection.effectiveType) || '';
        var clsEvent = {
          event: 'cumulative-layout-shift',
          cumulativeLayoutShift: maxCls || 0,
          originatingClientUriPath: window.location.pathname,
          htmlEdgeCacheStatus: htmlEdgeCacheStatus,
          cfCountryCode: cfCountryCode,
          effectiveType: effectiveType
        };
        window.localStorage.setItem(localStorage_constants.CLS_EVENT, JSON.stringify(clsEvent));
      }
    });
  } catch (e) {// Do nothing if the browser doesn't support this API
  }
};

/* harmony default export */ var utilities_trackCumulativeLayoutShift = (trackCumulativeLayoutShift_trackCumulativeLayoutShift);
// CONCATENATED MODULE: ./js/core/monitoring/performance.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






var fireInputDependentPerformanceEvent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var metrics, performanceEvent;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([new Promise(function (res) {
              return T(function (_ref2) {
                var value = _ref2.value;
                return res(value);
              });
            }), new Promise(function (res) {
              return b(function (_ref3) {
                var value = _ref3.value;
                return res(value);
              });
            })]);

          case 2:
            metrics = _context.sent;
            performanceEvent = {
              event: 'input-dependent-performance',
              firstInputDelay: metrics[0] || 0,
              largestContentfulPaint: metrics[1] || 0
            };
            dataLayer["a" /* default */].push(performanceEvent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fireInputDependentPerformanceEvent() {
    return _ref.apply(this, arguments);
  };
}();

window.addEventListener('load', function () {
  return fireInputDependentPerformanceEvent();
});

var fireCumulativeLayoutShiftEvent = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var storedClsEvent;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            storedClsEvent = JSON.parse(window.localStorage.getItem(localStorage_constants.CLS_EVENT));
            window.localStorage.removeItem(localStorage_constants.CLS_EVENT);

            if (storedClsEvent) {
              dataLayer["a" /* default */].push(storedClsEvent);
            }

            utilities_trackCumulativeLayoutShift();

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fireCumulativeLayoutShiftEvent() {
    return _ref4.apply(this, arguments);
  };
}();

window.addEventListener('load', function () {
  return fireCumulativeLayoutShiftEvent();
});

/***/ })

},[2854]);


// WEBPACK FOOTER //
// performance.50023c5c158c4502.js